import { FC } from 'react';
import type { CheckboxProps } from 'antd';
import { StyledFilterCheckbox } from './Checkbox.styled';


export const Checkbox: FC<CheckboxProps> = ({ ...rest }) => <StyledFilterCheckbox {...rest} />;
